import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import StreamgraphChart from './components/StreamgraphChart'
import StreamgraphChart2 from './components/StreamgraphChart2'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import SourceLink from '../../component/chartLinkData'
interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])

  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      RSV - Positivity rate among samples tested {season} (France - Lyon){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The graph shows the number of samples tested and the positivity rate for
              Influenza, SARS-CoV2, RSV and other respiratory viruses over the last
              week. Virological data are provided on a weekly basis by the Laboratoire
              de Biologie Médicale Multi Sites (LBMMS) from the Hospices Civils de Lyon.
              Data are available per respiratory virus and per age group (source BEHcl).
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart season={null} />
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <StreamgraphChart
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source'>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.chu-lyon.fr'>
                        {' '}
                        Hospices Civils de Lyon
                      </a>{' '}
                      , BEHcl
                    </i>{' '}
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
        <Modal
          // size="xl"
          className="modal-xxl"
          show={showSeasonModal}
          onHide={() => setShowSeasonModal(false)}
          centered
        >
          <Modal.Header closeButton className='py-4'>
            <Modal.Title className='bold'>
              <HeaderChart season={'2023-2024'} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <StreamgraphChart
              season={modalSeason}
              selectedAgeClass={selectedAgeClass}
              setSelectedAgeClass={setSelectedAgeClass}
            />
            <div className="d-flex justify-content-between align-items-center">
              <p className='card-text source'>
                <i>
                  Source:
                  <a className='fw-bold' href='https://www.chu-lyon.fr'>
                    {' '}
                    Hospices Civils de Lyon
                  </a>{' '}
                  , BEHcl
                </i>{' '}
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}
const DashboardPage2 = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'>
                  {' '}
                  Other Respiratory Viruses (ORV) - Positivity rate among samples tested (France -
                  Lyon)
                </h2>

                <p className='card-text p-2 bg-secondary rounded'>
                  Some quick example text to build on the card title and make up the bulk of the
                  card's content.
                </p>
              </div>
              <Card.Body className='row' style={{ marginTop: '-35px' }}>
                <StreamgraphChart2 />
                <p className='card-text source'>
                  <i>Source: Hospices Civils de Lyon, Laboratoire de biologie (LBMMS)</i>{' '}
                  <img
                    //className='mb-1'
                    style={{ width: '12px' }}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const Rsv = () => {
  const intl = useIntl()
  return (
    <>
      <div className='mb-5'>
        <DashboardPage />
      </div>
      {/* <div  className='mb-5'>
        <DashboardPage2 />
        </div> */}
    </>
  )
}

export { Rsv }
